import { defaultLocale } from '@ae/i18n';

/**
 * Changes the locale of the current page.
 *
 * @param newLocale - The new locale to set.
 */
export const changeLocaleFn = (newLocale: string) => {
  if (typeof window === 'undefined') return;

  const { host, protocol, pathname, search } = window.location;
  const cleanHost = host
    .replace('www.', '')
    .replace(/(fr|en|de|nl)\./, '')
    .replace(/\.(fr|en|de|nl)/, '.be');
  const hostPrefix = newLocale === defaultLocale ? 'www' : newLocale;
  const domain = `${protocol}//${hostPrefix}.${cleanHost}`;

  const queryString = search
    ? `?${new URLSearchParams(search).toString()}`
    : '';

  window.location.href = `${domain}${pathname === '/' ? '' : pathname}${queryString}`;
};
